import { Injectable } from "@angular/core";
import { IID_EP_ASSET } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDepAssetsStore } from "./iidEPAssets.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ASSETS)
export class IIDepAssetsQuery extends AbstractInterfaceDataQuery<IID_EP_ASSET> {

  constructor(protected store: IIDepAssetsStore) {
    super(store);
  }
}
